import React, { useState } from "react";

export default function WebsiteBanner() {
  const [banners] = useState([
    {
      id: 1,
      imageUrl: require("./../../images/solar.jpg"),
      link: "https://www.solar.infrioindia.com/solar-crm",
      alt: "Get in Touch with Infrio Solar",
    },
    {
      id: 2,
      imageUrl: require("./../../images/property.jpg"),
      link: "https://www.property.infrioindia.com/property-seller-packages",
      alt: "Get in Touch with Infrio Properties",
    },
  ]);

  return (
    <section className="section-full pt-5 pb-5 bg-white">
      <div className="container">
        <div className="section-head">
          <div className="sx-separator-outer separator-center">
            <div
              className="sx-separator bg-white bg-moving bg-repeat-x"
              style={{ backgroundImage: 'url(' + require("./../../images/background/cross-line2.png") + ')' }}
            >
              <h3 className="sep-line-one">Other Services</h3>
            </div>
          </div>
        </div>
        <div className="seller-package-banner-grid">
          {banners.map((banner) => (
            
              <div key={banner.id} className="seller-package-image-banner">
                <a href={banner.link} target="_blank" rel="noopener noreferrer">
                  <img src={banner.imageUrl} alt={banner.alt} title={banner.alt} />
                </a>
              </div>
          ))}
        </div>
      </div>
    </section>
  );
}
